import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col lg:flex-row items-center justify-between px-14" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold my-20 lg:my-32" }, "PRODUTOS")
], -1)
const _hoisted_2 = { class: "flex px-14 gap-10 justify-center items-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElImage = _resolveComponent("ElImage")!
  const _component_ElCarouselItem = _resolveComponent("ElCarouselItem")!
  const _component_ElCarousel = _resolveComponent("ElCarousel")!
  const _component_Products = _resolveComponent("Products")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ElCarousel, {
      class: "w-screen h-72 sm:h-80 lg:h-screen",
      arrow: "always",
      height: "auto"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slide, (item) => {
          return (_openBlock(), _createBlock(_component_ElCarouselItem, {
            key: item.imagem,
            style: {"height":"auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElImage, {
                src: `${_ctx.env}storage/${item.imagem}`,
                class: "w-full h-72 sm:h-80 lg:h-screen"
              }, null, 8, ["src"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.slides.length !== 0]
    ]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product, (destaque) => {
        return (_openBlock(), _createBlock(_component_Products, {
          key: destaque.id,
          product: destaque,
          options: _ctx.option
        }, null, 8, ["product", "options"]))
      }), 128))
    ])
  ], 64))
}